/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPagingResponseOfAllotmentReportFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeAgGridClientQuery, serializePagingResponseOfAllotmentReport, type AgGridClientQuery, type PagingResponseOfAllotmentReport, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /AllotmentReport/Get
 */
export interface GetRequestBuilder extends BaseRequestBuilder<GetRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagingResponseOfAllotmentReport>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<PagingResponseOfAllotmentReport | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const GetRequestBuilderUriTemplate = "{+baseurl}/AllotmentReport/Get";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: GetRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagingResponseOfAllotmentReportFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAgGridClientQuery,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
